import ActualAdvanceSettingDTO from "features/requirements/dtos/ActualAdvanceSettingDTO";
import AdvanceCanReduceDTO from "features/requirements/dtos/AdvanceCanReduceDTO";
import { FormFields, FormValidations, SetValidationRuleFunction } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const advanceFormValidations = (): FormValidations => {
  return {
    DESC_TMzalohySmlouva: {
      required: true,
      type: "OnlyRequired"
    }
  };
}

export const setAdvancesValidations = (advances: ActualAdvanceSettingDTO[], setValidationRule: SetValidationRuleFunction) => {
  clearAdvancesValidations(setValidationRule);

  const rule: PatternValidatonRule = {
    required: true,
    regex: /^(\d+(?:[\.\,]\d{1,2})?)$/,
    message: "invalidTwoDecimalsNumber",
    type: "Pattern"
  };

  for (const advance of advances) {
    setValidationRule(`DESC_TMzalohyNovaVyse${advance.orderOfDueDate}`, rule);
  }
}


export const clearAdvancesValidations = (setValidationRule: SetValidationRuleFunction) => {
  let countOfDueDates = 5;

  for (let i = 1; i <= countOfDueDates; i++) {
    setValidationRule(`DESC_TMzalohyNovaVyse${i}`, null, "remove");
  }
}

export const validateAdvancesDecrease = (
  advanceReduce: AdvanceCanReduceDTO,
  actualAdvances: ActualAdvanceSettingDTO[],
  values: FormFields
): boolean => {
  if (!advanceReduce.canReduce) {
    if (actualAdvances.length > 0) {
      let actualAdvancesSum = 0;
      let newAdvancesSum = 0;

      for (const advance of actualAdvances) {
        actualAdvancesSum += toNumber(advance.amount);
        newAdvancesSum += toNumber(values[`DESC_TMzalohyNovaVyse${advance.orderOfDueDate}`]);
      }

      return !(newAdvancesSum < actualAdvancesSum);
    }
  }

  return true;
};

const toNumber = (value: number | undefined | string): number => {
  if (value === undefined || value === null) {
    return 0;
  } else if (typeof value === "string") {
    return Number(value.replace(",", "."));
  } else {
    return value;
  }
};